export const JOB_STATUS = {
  HOLDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  WRAPPED: 'WRAPPED',
  ARCHIVED: 'ARCHIVED',
  HOLD: 'HOLD'
};

export const IS_HIDE_HOLDING_JOBS = Boolean(
  process.env.REACT_APP_IS_HIDE_HOLDING_JOBS === 'true'
);

export const IS_HIDE_PAY_WITH_INVOICE_OPTION = Boolean(
  process.env.REACT_APP_IS_HIDE_PAY_WITH_INVOICE_OPTION === 'true'
);